import { WorksheetImagesAndRemarksSection, WorksheetRootComponent } from 'Components/Worksheets/Core';
import { withInjectedProps } from '../../Core/InjectedPropsContext';
import { PageSection } from '../../Layout';
import qestIds from '../QestIds';
import { AggregateSamplingDetailsSection } from './Sections';

let AggregateSamplingCertificate: WorksheetRootComponent = () => {
  return (
    <>
      <PageSection heading="Sampling Details">
        <AggregateSamplingDetailsSection />
      </PageSection>

      <PageSection heading="Images and Remarks">
        <WorksheetImagesAndRemarksSection />
      </PageSection>
    </>
  );
};

AggregateSamplingCertificate = withInjectedProps(AggregateSamplingCertificate);
AggregateSamplingCertificate.qestIds = [qestIds.samplingCertificate.BS_EN_932_1_Rev1997];

export default AggregateSamplingCertificate;
export { AggregateSamplingCertificate };
